/**
 * @generated SignedSource<<3e0fbe1e4f6478d99b6aba06b32ec79e>>
 * @relayHash 319dfec69263bf13f5b2668b31e56c50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f30656e4deb2d0fae7641e86f6e92b9c3996c4617c63ef29a872838acd3a6ccb

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type GoalUpdatesViewAggQuery$variables = {
  containerId: string;
  endDate: AGG$DateTime;
  followingGoalsSearchString: string;
  prevDate: AGG$DateTime;
  startDate: AGG$DateTime;
  stateFilter?: TownsquareUpdateStateFilter | null;
};
export type GoalUpdatesViewAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesMainColumnAgg">;
};
export type GoalUpdatesViewAggQuery = {
  response: GoalUpdatesViewAggQuery$data;
  variables: GoalUpdatesViewAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followingGoalsSearchString"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v6 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v7 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "startDate"
},
v13 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "endDate"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "missed"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
],
v15 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v16 = [
  (v6/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v19 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v20 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v21 = {
  "kind": "ScalarField",
  "name": "summary"
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = {
  "kind": "ScalarField",
  "name": "score"
},
v24 = [
  (v22/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "description"
},
v26 = {
  "kind": "ScalarField",
  "name": "archived"
},
v27 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v21/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ]
        }
      ]
    }
  ]
},
v28 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v29 = {
  "kind": "ScalarField",
  "name": "picture"
},
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v32 = [
  (v11/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v17/*: any*/)
],
v33 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v32/*: any*/)
},
v35 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v36 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "type"
},
v38 = {
  "kind": "ScalarField",
  "name": "subType"
},
v39 = {
  "kind": "ScalarField",
  "name": "source"
},
v40 = {
  "kind": "ScalarField",
  "name": "time"
},
v41 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v17/*: any*/)
  ]
},
v42 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v43 = [
  (v22/*: any*/),
  (v40/*: any*/),
  (v17/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v45 = {
  "kind": "ScalarField",
  "name": "start"
},
v46 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v47 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v48 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v17/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v50 = [
  (v22/*: any*/)
],
v51 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v52 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v51/*: any*/)
  ]
},
v53 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v51/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v55 = [
  (v37/*: any*/),
  (v54/*: any*/)
],
v56 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v58 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v54/*: any*/),
    (v37/*: any*/)
  ]
},
v59 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v30/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v26/*: any*/),
                (v44/*: any*/),
                (v39/*: any*/),
                (v41/*: any*/)
              ]
            },
            (v48/*: any*/),
            (v46/*: any*/),
            (v47/*: any*/)
          ]
        }
      ]
    }
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "url"
},
v61 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v62 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v61/*: any*/)
  ]
},
v63 = [
  (v11/*: any*/),
  (v31/*: any*/),
  (v30/*: any*/),
  (v29/*: any*/),
  (v17/*: any*/)
],
v64 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v63/*: any*/)
},
v65 = {
  "kind": "ScalarField",
  "name": "label"
},
v66 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v63/*: any*/)
},
v67 = [
  (v20/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v22/*: any*/),
      (v23/*: any*/),
      (v65/*: any*/)
    ]
  },
  (v21/*: any*/),
  (v66/*: any*/),
  (v27/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v17/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v28/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v20/*: any*/),
              (v35/*: any*/)
            ]
          }
        ]
      },
      (v36/*: any*/)
    ]
  },
  (v17/*: any*/)
],
v68 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v67/*: any*/)
},
v69 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v70 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v71 = {
  "kind": "ScalarField",
  "name": "key"
},
v72 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v71/*: any*/)
  ]
},
v73 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v24/*: any*/)
},
v74 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v75 = {
  "args": [
    (v10/*: any*/)
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            (v74/*: any*/),
            (v20/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v76 = [
  (v17/*: any*/)
],
v77 = [
  (v65/*: any*/),
  (v61/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesViewAggQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "followingGoalsSearchString",
            "variableName": "followingGoalsSearchString"
          },
          {
            "kind": "Variable",
            "name": "prevDate",
            "variableName": "prevDate"
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesMainColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesViewAggQuery",
    "selections": [
      {
        "alias": "followingGoals",
        "args": [
          (v6/*: any*/),
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "followingGoalsSearchString"
          }
        ],
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareGoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v11/*: any*/)
            ]
          }
        ]
      },
      {
        "alias": "allGoalUpdatesInPeriodCount",
        "args": [
          (v6/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "goals_allWatchedGoalUpdatesCount"
      },
      {
        "alias": "currentSummary",
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "concreteType": "TownsquareStatusSummary",
        "kind": "LinkedField",
        "name": "goals_statusSummary",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "previousSummary",
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "startDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "prevDate"
          }
        ],
        "concreteType": "TownsquareStatusSummary",
        "kind": "LinkedField",
        "name": "goals_statusSummary",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "args": (v16/*: any*/),
        "concreteType": "TownsquareUpdateConnection",
        "kind": "LinkedField",
        "name": "goals_allWatchedGoalUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v27/*: any*/),
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v25/*: any*/),
                                  (v11/*: any*/),
                                  (v17/*: any*/),
                                  (v28/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v20/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v36/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v30/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v26/*: any*/),
                                      (v39/*: any*/),
                                      (v41/*: any*/),
                                      {
                                        "args": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v43/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v43/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v17/*: any*/),
                                      (v22/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v26/*: any*/),
                                          (v30/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v44/*: any*/),
                                          (v39/*: any*/),
                                          (v41/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v45/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v22/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v17/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v17/*: any*/),
                          (v49/*: any*/),
                          (v26/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v17/*: any*/)
                                ]
                              },
                              (v17/*: any*/)
                            ]
                          },
                          (v56/*: any*/),
                          {
                            "args": (v57/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v30/*: any*/),
                                      (v26/*: any*/),
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v60/*: any*/),
                                      (v49/*: any*/),
                                      (v62/*: any*/),
                                      (v64/*: any*/),
                                      (v68/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v52/*: any*/),
                                          (v53/*: any*/),
                                          (v72/*: any*/),
                                          (v17/*: any*/)
                                        ]
                                      },
                                      (v73/*: any*/),
                                      (v75/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v30/*: any*/),
                                      (v26/*: any*/),
                                      (v58/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "kind"
                                          },
                                          (v17/*: any*/),
                                          (v72/*: any*/)
                                        ]
                                      },
                                      (v59/*: any*/),
                                      (v60/*: any*/),
                                      (v49/*: any*/),
                                      (v62/*: any*/),
                                      (v64/*: any*/),
                                      (v68/*: any*/),
                                      (v70/*: any*/),
                                      (v73/*: any*/),
                                      (v75/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": [
                              (v15/*: any*/)
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v21/*: any*/),
                                                  (v25/*: any*/),
                                                  (v17/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isWatching"
                          },
                          (v69/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canCommentOnUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canCreateUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canDeleteUpdates"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v76/*: any*/)
                          },
                          (v71/*: any*/),
                          (v30/*: any*/),
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v71/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                          },
                          (v70/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                          }
                        ]
                      },
                      (v66/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v77/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v55/*: any*/)
                      },
                      {
                        "args": (v57/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/)
                                    ]
                                  },
                                  (v17/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v67/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v30/*: any*/),
                                  (v56/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v49/*: any*/),
                                  (v62/*: any*/),
                                  (v64/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v31/*: any*/),
                          (v30/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      (v74/*: any*/),
                      {
                        "args": [
                          (v42/*: any*/)
                        ],
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v17/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v76/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v76/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v17/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "viewers(first:100)"
                      },
                      (v60/*: any*/),
                      {
                        "concreteType": "TownsquareCommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareCommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareComment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v30/*: any*/),
                                      (v17/*: any*/),
                                      (v31/*: any*/),
                                      (v29/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v74/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v36/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v77/*: any*/)
                      }
                    ],
                    "type": "TownsquareGoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v76/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v16/*: any*/),
        "filters": [
          "containerId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "GoalUpdatesList_goals_allWatchedGoalUpdates",
        "kind": "LinkedHandle",
        "name": "goals_allWatchedGoalUpdates"
      }
    ]
  },
  "params": {
    "id": "f30656e4deb2d0fae7641e86f6e92b9c3996c4617c63ef29a872838acd3a6ccb",
    "metadata": {},
    "name": "GoalUpdatesViewAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1777ec1c89d3b9ff381878c80e40ac4d";

export default node;
